<script lang="ts">
  import { getContext } from "svelte"
  import {
    ParsedWidget,
    parseElementsForSelector,
  } from "website_script/lib/Parsers"
  import InlineButton from "./InlineButton.svelte"
  import type { Settings } from "website_script/types/settings"
  import { getInlineButtonSupportedModuleTypes } from "website_script/lib/Helpers"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import { DefaultInlineButtonsCssSelectors } from "website_script/constants/DefaultCssSelectors"
  import type { ButtonConfig } from "website_script/types/widgets"
  import InlineWidget from "website_script/components/InlineWidget.svelte"

  const dealerTheme = getContext<DealerTheme>("dealerTheme")
  const settings = getContext<Settings>("settings")
  const { inlineButtonsConfig, leadFlows, selectorToAppendPriceAlertCta } =
    settings

  const selectorsForFlowType = {
    trade_in: DefaultInlineButtonsCssSelectors.inlineCta,
    test_drive: DefaultInlineButtonsCssSelectors.bookTestDriveCta,
    price_alert:
      selectorToAppendPriceAlertCta ||
      DefaultInlineButtonsCssSelectors.priceAlertCta,
  }

  const parsedButtons: ParsedWidget[] = inlineButtonsConfig.buttons.flatMap(
    (button) => {
      const customButtonConfig = leadFlows?.inlineButtonSelectors?.find(
        (cb) => cb.lead_flow_id === button.lead_flow_id
      )

      const selector =
        customButtonConfig?.json_value ??
        selectorsForFlowType[
          button.flow_type as keyof typeof selectorsForFlowType
        ]

      if (!selector) return []

      return parseElementsForSelector(selector, {
        leadFlowId: button.lead_flow_id,
      })
    }
  )

  type RenderableButton = {
    target: ParsedWidget["elTarget"]
    data: ParsedWidget["elData"]
    config: ButtonConfig
  }

  const renderableButtons: RenderableButton[] = parsedButtons.flatMap((pb) => {
    const matchingButton = inlineButtonsConfig.buttons.find(
      (b) => b.lead_flow_id === pb.leadFlowId
    )
    if (!matchingButton) return []

    return {
      target: pb.elTarget,
      data: pb.elData,
      config: matchingButton,
    }
  })
</script>

{#each renderableButtons as button}
  <InlineWidget target={button.target} theme={dealerTheme}>
    <InlineButton
      moduleType={getInlineButtonSupportedModuleTypes(button.config.flow_type)}
      buttonConfig={button.config}
      elementData={button.data}
    />
  </InlineWidget>
{/each}
